import React, { useRef } from 'react';
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import {
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    ButtonDropdown
} from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { useQuery } from '@apollo/react-hooks';

import _ from 'lodash';

import { toggleRightSidebar } from "../../store/actions";
import { withTranslation } from 'react-i18next';
import { connect } from "react-redux";
import 'react-medium-image-zoom/dist/styles.css'
import { GET_CATEGORY } from '../../graphql/query/GET_CATEGORY';
import NewCategory from './new-category';
import EditCategory from './edit-category';
import ManagePlatform from './category-platform';
import { ME } from '../../graphql/query';
import { OperatingUsers, Operator } from '../../assets/scss/role.constant';

function CategoryList(props) {

    const [addCategory, setAddCategory] = React.useState(false)
    const [editCategory, setEditCategory] = React.useState(false)
    const [search, setSearch] = React.useState('')
    const [searchValue, setSearchValue] = React.useState('')
    const [isSearch, setIsSearch] = React.useState(false)
    const [editItem, setEditItem] = React.useState(null)
    const [categoryItem, setCategoryItem] = React.useState(null)
    const [manageCategory, setManageCategory] = React.useState(false)

    const { data: categoryData, refetch } = useQuery(GET_CATEGORY, {
        variables: {
            filter: {
                and: [
                    {
                        or: [
                            { name: { iLike: `%${search}%` } }
                        ]
                    },
                ]
            },
            sorting: {
                field: "name",
                direction: "ASC"
            }
        },
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'network-only'
    });

    const { data: meData } = useQuery(ME, {
        fetchPolicy: 'cache-first'
    })

    const onEdit = (category) => {
        setCategoryItem(category)
        setEditCategory(true)
    }

    const debouncedSave = useRef(
        _.debounce(nextValue => setSearch(nextValue), 300)).current

    return (
        <React.Fragment>
            {
                meData && !OperatingUsers.includes(meData.me.role) && !Operator.includes(meData.me.role) &&
                <div className="page-content category-page">
                    <Container fluid>
                        <Breadcrumbs title="Landing Settings" breadcrumbItem="Category" />
                        <div className="search-bar-container">
                            <div className="button-add-category-container">
                                <div className="app-search d-none d-lg-block">
                                    <div className="position-relative">
                                        <input
                                            value={searchValue}
                                            type="text"
                                            className="form-control"
                                            placeholder="Search..."
                                            onChange={(e) => {
                                                setSearchValue(e.target.value)
                                                debouncedSave(e.target.value)
                                            }}
                                        />
                                        <span className="bx bx-search-alt"></span>
                                    </div>
                                </div>
                                <div className="d-flex">
                                    <div className="dropdown d-inline-block d-lg-none ml-2">
                                        <button
                                            type="button"
                                            className="btn header-item noti-icon waves-effect"
                                            id="page-header-search-dropdown"
                                            onClick={() => { setIsSearch(!isSearch) }}>
                                            <i className="mdi mdi-magnify"></i>
                                        </button>
                                        <div
                                            className={isSearch ? "dropdown-menu dropdown-menu-lg dropdown-menu-right p-0 show" : "dropdown-menu dropdown-menu-lg dropdown-menu-right p-0"}
                                            aria-labelledby="page-header-search-dropdown"
                                        >
                                            <form className="p-3">
                                                <div className="form-group m-0">
                                                    <div className="input-group">
                                                        <input
                                                            value={searchValue}
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Search..."
                                                            onChange={(e) => {
                                                                setSearchValue(e.target.value)
                                                                debouncedSave(e.target.value)
                                                            }}
                                                        />
                                                        <div className="input-group-append">
                                                            <button className="btn btn-primary" type="submit">
                                                                <i className="mdi mdi-magnify"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>


                            </div>
                            <div className="button-add-category-container">
                                {/* <div className="filter-container button-filter-container mr-2">
                                <button type="button" className="waves-effect btn btn-outline-secondary button-add-category" onClick={() => {
                                    props.toggleRightSidebar();
                                }}>
                                    <i className="bx bxs-filter-alt font-size-15 align-middle mr-2 filter"></i> | <i className="bx bx-sort font-size-15 align-middle mr-2 sort"></i>
                                </button>
                            </div> */}
                                <button type="button" className="waves-effect btn btn-outline-secondary button-add-category" onClick={() => { setAddCategory(true) }}>
                                    <i className="bx bx-plus font-size-15 align-middle mr-2"></i>New Category
                                </button>
                            </div>
                        </div>
                        <Row>
                            {
                                categoryData &&
                                categoryData.categories.edges.length > 0 &&
                                categoryData.categories.edges.map((category, key) =>
                                    <Col xl="3" sm="6" lg="4" key={key}>
                                        <Card>
                                            <CardBody style={{ padding: '15px 1.25rem' }}>
                                                <Row>
                                                    <Col>
                                                        <div className="pb-3 align-center">
                                                            <img
                                                                className="category-image-list"
                                                                src={category.node.logoUrl}
                                                                alt=""
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col xl="12" sm="12" className="padding-bottom text-align cursor-pointer " onClick={() => {
                                                        onEdit(category)
                                                    }}>
                                                        <div>
                                                            <div className="header">Category Name</div>
                                                            <div className="font-size-14"><div className="text-dark">{category.node.name}</div></div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col xl="12" sm="12" className="padding-bottom text-align cursor-pointer " onClick={() => {
                                                        onEdit(category)
                                                    }}>
                                                        <div>
                                                            <div className="header">Slug</div>
                                                            <div className="font-size-14"><div className="text-dark">{category.node.slug}</div></div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col xl="12" sm="12" className="padding-bottom text-align cursor-pointer " onClick={() => {
                                                        setCategoryItem(category)
                                                        setManageCategory(true)
                                                    }}>
                                                        <div>
                                                            <div className="header">Platforms</div>
                                                            <div className="tag-wrapper">
                                                                {
                                                                    category.node.platforms.edges.map((platform, index) => {
                                                                        return <div className="tag" key={index}>{platform.node.displayName}</div>
                                                                    })
                                                                }
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col xl="12" sm="12" className="padding-bottom text-align cursor-pointer " onClick={() => {
                                                        onEdit(category)
                                                    }}>
                                                        <div>
                                                            <div className="header">Active?</div>
                                                            <div className="font-size-14"><div className="text-dark">{category.node.isActive ? 'true' : 'false'}</div></div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className="dropdown-actions">
                                                        <ButtonDropdown
                                                            isOpen={editItem === category}
                                                            toggle={() => {
                                                                if (editItem) {
                                                                    setEditItem(null)
                                                                } else {
                                                                    setEditItem(category)
                                                                }
                                                            }}
                                                        >
                                                            <DropdownToggle caret color="secondary">
                                                                Actions <i className="mdi mdi-chevron-down"></i>
                                                            </DropdownToggle>
                                                            <DropdownMenu right>
                                                                <DropdownItem onClick={() => {
                                                                    setCategoryItem(category)
                                                                    setEditCategory(true)
                                                                }}>Edit category</DropdownItem>
                                                                <DropdownItem onClick={() => {
                                                                    setCategoryItem(category)
                                                                    setManageCategory(true)
                                                                }}>Manage Platform</DropdownItem>
                                                            </DropdownMenu>
                                                        </ButtonDropdown>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                )
                            }
                            {
                                categoryData &&
                                categoryData.categories.edges.length === 0 &&
                                <Col xl="12" sm="12">
                                    <div className="text-center">No Category Found</div>
                                </Col>
                            }
                        </Row>
                        <NewCategory
                            modal={addCategory}
                            toggleModal={() => {
                                setAddCategory(!addCategory)
                                refetch()
                            }}
                        />
                        <EditCategory
                            modal={editCategory}
                            category={categoryItem}
                            toggleModal={() => {
                                setEditCategory(!editCategory)
                            }}
                        />
                        <ManagePlatform
                            modal={manageCategory}
                            category={categoryItem}
                            toggleModal={() => {
                                setManageCategory(!manageCategory)
                            }}
                        />
                    </Container>
                </div>
            }
        </React.Fragment >
    );
    // }
}

const mapStatetoProps = state => {
    const { layoutType } = state.Layout;
    return { layoutType };
};

export default connect(mapStatetoProps, { toggleRightSidebar })(withTranslation()(CategoryList));

// export default ContactsList;